/**
 * UserSessionContext - Wrapper de compatibilidad
 * 
 * Este archivo mantiene la interfaz anterior para que los componentes existentes
 * que usan useUserSession() sigan funcionando sin cambios.
 * 
 * Internamente consume el AuthProvider unificado.
 */
import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthProvider';

const UserSessionContext = createContext(null);

/**
 * UserSessionProvider - Wrapper que expone la interfaz legacy
 * 
 * NOTA: Este provider ya no hace nada por sí mismo.
 * Solo existe para mantener compatibilidad hacia atrás.
 * El AuthProvider (en index.js) es el que realmente maneja la autenticación.
 */
export function UserSessionProvider({ children }) {
  // Este provider es ahora un pass-through
  // La lógica real está en AuthProvider
  return (
    <UserSessionContext.Provider value={null}>
      {children}
    </UserSessionContext.Provider>
  );
}

/**
 * Hook useUserSession - Interfaz de compatibilidad
 * 
 * Devuelve la misma estructura que antes:
 * { user, session, loading, logout, profile }
 * 
 * Pero internamente lee del AuthProvider.
 */
export function useUserSession() {
  const auth = useAuth();
  
  // Mapear a la interfaz legacy
  return {
    // user aquí es el session.user de Supabase (para email_confirmed_at, etc.)
    user: auth.sessionUser,
    // session completa de Supabase
    session: auth.session,
    // loading = SOLO carga de sesión (NO incluye profileLoading)
    // Así App.js muestra "Cargando" solo mientras getSession() resuelve (<200ms)
    loading: auth.loading,
    // logout robusto
    logout: auth.logout,
    // profile es el user normalizado (para compatibilidad)
    profile: auth.user,
  };
}

export default UserSessionProvider;
